import { IS_DEV, IS_STAGING, IS_PRODUCTION } from '../../../constants/ssr'

export const environment = () => {
  if (IS_PRODUCTION) return 'production'
  if (IS_STAGING) return 'staging'
  if (IS_DEV) return 'development'
  return 'development' // default to development
}
